import {
  useWSModalCustom,
  WSActions,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { InvoiceStatus } from "@wingspanhq/payments/dist/interfaces";
import { WSQueryCache } from "@ws-react-query";
import React, { useState } from "react";
import { addNotification } from "../../../components/Notification/Notification";
import { QUERY_PAYABLE, QUERY_PAYABLES } from "../../../query/payments/keys";
import { paymentsService } from "../../../services/payments";
import { bulkActionFactory } from "../../../utils/bulkActionFactory";
import { PayablesTableItemData } from "./PayablesTable";

type Props = {
  data: PayablesTableItemData[];
  onSuccess?(): void;
} & WSModalCustomProps<any>;

export const ModalBulkOpen: React.FC<Props> = ({
  data,
  onSuccess,
  ...modalProps
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const bulkOpen = bulkActionFactory({
    onStart: () => {
      setIsLoading(true);
    },
    action: async (item: PayablesTableItemData) => {
      const payableId = item.payable?.payableId || "";

      return await paymentsService.payable.update(payableId, {
        status: InvoiceStatus.Open
      });
    },
    onFinish: ({ successItems, failedItems }) => {
      WSQueryCache.invalidateQueries(QUERY_PAYABLES);
      successItems.forEach(item => {
        WSQueryCache.invalidateQueries([
          QUERY_PAYABLE,
          item.payable?.payableId
        ]);
      });

      addNotification({
        timeout: 6000,
        text:
          `${successItems.length} payable${
            successItems.length > 1 ? "s" : ""
          } have been opened` +
          (failedItems.length > 0 ? `, ${failedItems.length} failed` : "")
      });

      setIsLoading(false);

      onSuccess?.();
      modalProps.onClose?.(undefined);
    }
  });

  return (
    <WSModal
      blockClose={isLoading}
      title={`Open ${data.length} payable${data.length > 1 && "s"}?`}
      size="S"
      {...modalProps}
    >
      <WSText mb="XL">Open selected draft payables</WSText>

      <WSActions
        buttons={[
          {
            onClick: () => {
              bulkOpen.run(data);
            },
            label: "Open",
            loading: isLoading
          },
          {
            onClick: () => {
              modalProps.onClose?.(undefined);
            },
            label: "Cancel",
            kind: "Tertiary"
          }
        ]}
      />
    </WSModal>
  );
};

export const useModalBulkOpen = () => useWSModalCustom(ModalBulkOpen);
